import axios from 'axios';
import toastr from 'toastr';
import config from 'config';
import update from 'immutability-helper';
import { updateLogo, setLogo, removeLogo } from 'actions/livefeed'

/*
	API
*/

export const GENERATE_API_KEY = "GENERATE_API_KEY"
export function generateAPIKey(auth) {
	return {
		type: GENERATE_API_KEY,
		auth
	}
}

export const GENERATE_API_KEY_OK = "GENERATE_API_KEY_OK"
export function generateAPIKeyOk(result) {
	return {
		type: GENERATE_API_KEY_OK,
		apikey: result.data
	}
}

export const GENERATE_API_KEY_FAIL = "GENERATE_API_KEY_FAIL"
export function generateAPIKeyFail(result) {
	return {
		type: GENERATE_API_KEY_FAIL,
		e: result
	}
}

export const CLEAR_API_KEY = "CLEAR_API_KEY"
export function clearAPIKey() {
	return {
		type: CLEAR_API_KEY
	}
}

/*
	LIVEFEED
*/

export const FETCH_TEMPLATE = "FETCH_TEMPLATE"
export function fetchTemplate() {
	return dispatch => {
		dispatch({ type: FETCH_TEMPLATE });
		return axios.get(config.api.root + `/livefeed/template`)
			.then((response) => {
				dispatch(receiveTemplate(response.data));
				return response;
			}).catch((error) => {
				console.log(error);
				toastr.error(error.statusText.data);
				return error;
			});
	}
}

export const RECEIVE_TEMPLATE = "RECEIVE_TEMPLATE"
export function receiveTemplate(data) {
	return {
		type: RECEIVE_TEMPLATE,
		data
	}
}

export const CREATE_TEMPLATE = "CREATE_TEMPLATE"
export function createTemplate(template, fClose) {
	return dispatch => {
		dispatch({ type: CREATE_TEMPLATE, template });
		console.log("template", template)
		return axios.post(config.api.root + `/livefeed/template/create`, template)
			.then((response) => {
				toastr.success("Template is created successfully !")
				if (typeof fClose == "function") {
					fClose();
				}
				return response;
			}).catch((error) => {
				console.log(error);
				toastr.error(error.statusText.data);
				return error;
			});
	}
}
export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE"
export function updateTemplate(url, fClose) {
	return dispatch => {
		dispatch({ type: UPDATE_TEMPLATE, url });
		return axios.put(config.api.root + `/livefeed/template/update/${url.key}`, url)
			.then((response) => {
				dispatch(fetchTemplate()).then(() => {
					toastr.success("Template edited successfully !")
					if (typeof fClose == "function") {
						fClose();
					}
				});
				return response;
			}).catch((error) => {
				console.log(error);
				let concatMessage = error.statusText.data.concat(' Someone in your team has deleted this template')
				console.log(concatMessage)

				toastr.error(concatMessage);
				return error;
			});
	}
}

export const DELETE_TEMPLATE = "DELETE_TEMPLATE"
export function deleteTemplate(tplId, fClose) {
	return dispatch => {
		dispatch({ type: DELETE_TEMPLATE, tplId });
		return axios.delete(config.api.root + `/livefeed/template/delete/${tplId}`)
			.then((response) => {
				dispatch(fetchTemplate()).then(() => {
					toastr.success("Template deleted successfully!")
					if (typeof fClose == "function") {
						fClose();
					}
				});
				return response;
			}).catch((error) => {
				console.log(error);
				let concatMessage = error.statusText.data.concat(' Someone in your team has deleted this template')
				toastr.error(concatMessage);
				return error;
			});
	}
}


export const UPLOAD_LOGO = "UPLOAD_LOGO"
export function uploadLogo(image) {
	return (dispatch, getState) => {
		const { livefeedSlides, slideCurrentIndex } = getState().livefeededitor;
		const { logoState } = livefeedSlides.slice()[slideCurrentIndex];
		let formData = new FormData();
		formData.append('logo', image);
		let axiosConfig = {
			headers: { 'Content-Type': 'multipart/form-data' },
			onUploadProgress: e => {
				console.log(e)
			}
		};
		dispatch({ type: UPLOAD_LOGO, image });
		toastr.info("Logo uploading !")
		return axios.put(config.api.root + `/livefeed/template/logo`, formData, axiosConfig)
			.then((response) => {
				toastr.success("Logo uploaded successfully !")
				// update local state
				const newLogoState = update(logoState, {
					slideCurrentIndex: { $set: slideCurrentIndex },
					url: { $set: response.data },
					show: { $set: true },
					activeToolbarItems: { [1]: { deletable: { $set: true } } }
				});
				dispatch(updateLogo(newLogoState));
				for (let i = 0; i < livefeedSlides.length; i++) {
					// Also update logo to other slides if it doesnt have a logo yet
					if (livefeedSlides[i].logoState.url === null) {
						let copyLogo = update(livefeedSlides[i].logoState, {
							slideCurrentIndex: { $set: i },
							show: { $set: true },
							url: { $set: response.data },
							activeToolbarItems: { [1]: { deletable: { $set: true } } }
						});
						dispatch(setLogo(copyLogo))
					}
				}
				return response;
			}).catch((error) => {
				console.log(error);
				toastr.error(error.statusText.data);
				return error;
			});
	}
}
export const DELETE_LOGO = "DELETE_LOGO"

export function deleteLogo(logoId, slideCurrentIndex) {
	return dispatch => {
		dispatch({ type: DELETE_LOGO });
		return axios.delete(config.api.root + `/livefeed/template/logo/${logoId}`)
			.then((response) => {
				toastr.success("Logo deleted successfully!")
				dispatch(removeLogo(slideCurrentIndex)) // update local logoState
				return response;
			}).catch((error) => {
				console.log(error);
				toastr.error(error.statusText.data);
				return error;
			});
	}
}

export const FETCH_LIVEFEED = "FETCH_LIVEFEED"
export function fetchLivefeed() {
	return dispatch => {
		dispatch({ type: FETCH_LIVEFEED });
		return axios.get(config.api.root + `/livefeed`)
			.then((response) => {
				dispatch(receiveLivefeed(response.data));
				return response;
			}).catch((error) => {
				console.log(error);
				toastr.error(error.statusText.data);
				return error;
			});
	}
}

export const RECEIVE_LIVEFEED = "RECEIVE_LIVEFEED"
export function receiveLivefeed(data) {
	return {
		type: RECEIVE_LIVEFEED,
		data
	}
}

export const CREATE_LIVEFEED = "CREATE_LIVEFEED"
export function createLivefeed(url, emails, fClose) {
	return dispatch => {
		dispatch({ type: CREATE_LIVEFEED, url, emails });
		return axios.post(config.api.root + `/livefeed/create`, url)
			.then((response) => {
				console.log("response", response)
				var key = response.data.key;

				dispatch(addUsersToURL(key, emails))

				toastr.success("Livefeed created successfully !")
				if (typeof fClose == "function") {
					fClose();
				}

				return response;
			}).catch((error) => {
				console.log(error);
				toastr.error(error.statusText.data);
				return error;
			});
	}
}

export const UPDATE_LIVEFEED = "UPDATE_LIVEFEED"
export function updateLivefeed(url, fClose) {
	return dispatch => {
		dispatch({ type: UPDATE_LIVEFEED, url });
		return axios.put(config.api.root + `/livefeed/update/${url.key}`, url)
			.then((response) => {

				dispatch(fetchLivefeed()).then(() => {
					toastr.success("Livefeed edited successfully !")
					if (typeof fClose == "function") {
						fClose();
					}
				});

				return response;
			}).catch((error) => {
				console.log(error);
				let concatMessage = error.statusText.data.concat(' Someone in your team has deleted this livefeed')
				toastr.error(concatMessage);
				return error;
			});
	}
}

export const DELETE_LIVEFEED = "DELETE_LIVEFEED"
export function deleteLivefeed(urlkey, fClose) {
	return dispatch => {
		dispatch({ type: DELETE_LIVEFEED, urlkey });
		return axios.delete(config.api.root + `/livefeed/delete/${urlkey}`)
			.then((response) => {
				dispatch(fetchLivefeed()).then(() => {
					toastr.success("Livefeed deleted successfully!")
					if (typeof fClose == "function") {
						fClose();
					}
				})

				return response;
			}).catch((error) => {
				console.log(error);
				let concatMessage = error.statusText.data.concat(' Someone in your team has deleted this livefeed')
				toastr.error(concatMessage);
				return error;
			});
	}
}

export const ADD_USERS_TO_URL = "ADD_USERS_TO_URL"
export const ADD_USERS_TO_URL_STATUS = "ADD_USERS_TO_URL_STATUS"

export function addUsersToURL(key, emails, fClose) {
	return dispatch => {
		if (emails.length == 0) {
			return null;
		}
		var email = emails[0];
		dispatch({ type: ADD_USERS_TO_URL, key: key, email: email });
		var userurl = {
			email: email,
			urlkey: key
		}
		var send = () => {
			if (emails.length > 1) {
				dispatch(addUsersToURL(key, emails.slice(1), fClose));
			} else {
				// reload Livefeed list
				dispatch(fetchLivefeed()).then(() => {
					if (typeof fClose == "function") {
						fClose();
					}
				});
			}
		}
		return axios.post(config.api.root + `/livefeed/userurl`, userurl)
			.then((response) => {
				toastr.success(`Sent livefeed invitation to ${email} successfully!`)
				dispatch({ type: ADD_USERS_TO_URL_STATUS, bool: true });
				send();
				return response;
			}).catch((error) => {
				console.log(error);
				toastr.error(error.data);
				dispatch({ type: ADD_USERS_TO_URL_STATUS, bool: false });
				send();
				return error;
			});
	}
}

export const REMOVE_USER_FROM_URL = "REMOVE_USER_FROM_URL"
export const REMOVE_USER_FROM_URL_STATUS = "REMOVE_USER_FROM_URL_STATUS"
export function removeUserFromURL(key, email, fClose) {
	return dispatch => {
		dispatch({ type: REMOVE_USER_FROM_URL, key: key, email: email });
		var userurl = {
			email: email,
			urlkey: key
		}
		return axios.delete(config.api.root + `/livefeed/userurl/${key}/${email}`, userurl)
			.then((response) => {
				toastr.success(`Removed ${email} from livefeed users successfully!`)
				dispatch({ type: REMOVE_USER_FROM_URL_STATUS, bool: true });
				dispatch(fetchLivefeed()).then(() => {
					if (typeof fClose == "function") {
						fClose();
					}
				});
				return response;
			}).catch((error) => {
				console.log(error);
				dispatch({ type: REMOVE_USER_FROM_URL_STATUS, bool: false });
				toastr.error(error.statusText.data);
				return error;
			});
	}
}


export const PREVIEW_LIVEFEED = "PREVIEW_LIVEFEED"
export function previewLivefeed(url) {
	return dispatch => {
		dispatch({ type: PREVIEW_LIVEFEED, url });
		return axios.post(config.api.root + `/livefeed/preview/${url.key}`)
			.then((response) => {
				console.log(response);
				var previewUrl = (config.livefeed.root + "/#/url?k=" + url.key + "&apikey=" + response.data.token);
				var win = window.open(previewUrl, '_blank');
				win.focus();
				// console.log(config.livefeed.root + "/#/url?k="+url.key+"&apikey="+response.data.token)
				return response;
			}).catch((error) => {
				console.log(error);
				toastr.error(error.statusText.data);
				return error;
			});
	}
}



// WEBPACK FOOTER //
// ./src/actions/livefeedapi.jsx